module.exports = __webpack_public_path__ + "static/media/addMemberGuide1_Jap.2c49d6da.png";